// react
import React from 'react';

// components
import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';

// mui
import { Stack } from '@mui/material';

export const LoadingArticleContent = () => {
  return (
    <Stack
      sx={{
        width: '100%',
      }}
    >
      {[1, 2, 3].map((n) => (
        <React.Fragment key={n}>
          <Skeleton shape='title' />
          <Skeleton shape='paragraph' />
          <Skeleton shape='subtitle' />
          <Skeleton shape='paragraph' />
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default LoadingArticleContent;
